import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
import Scholarships from './pages/scholarships';
import Events from './pages/events';
import Academics from './pages/academics';
import Admissions from './pages/admissions';
import Pagenotfound from './pages/pagenotfound';

function App() {
  return (
   <Router basename='/'>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/About' element={<About/>}/>
        <Route path='/Contact' element={<Contact/>}/>
        <Route path='/Scholarships' element={<Scholarships/>}/>
        <Route path='/Events' element={<Events/>}/>
        <Route path='/Academics' element={<Academics/>}/>
        <Route path='/Admissions' element={<Admissions/>}/>
        <Route path='*' element={<Pagenotfound/>}/>
      </Routes>
   </Router>
  );
}

export default App;
